import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sessionDisplay'
})
export class SessionDisplayPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    switch (value) {
      case 1:
        return 'Drop-in Session';
      default:
        return value + ' Sessions';
    }
  }
}
